import { Component, OnInit } from '@angular/core';
import { Subject, generate } from "rxjs";
import { Router } from "@angular/router";
import { AdsService } from '../Services/ads.service';
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CardServiceService } from '../Services/card-service.service';
import { CookieService } from '../Services/cookie';
import { generateKey } from 'js-crypto-rsa';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: "app-landing-page-offers",
  templateUrl: "./landing-page-offers.component.html",
  standalone:false,
  styleUrls: ["./landing-page-offers.component.scss"],
})
export class LandingPageOffersComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  Adsoffer: any;
  OfferCategories: any;
  OfferPaginated: any;
  totalpages: number[] = [];
  FavouriteOffers: any;
  Categoryid: any;
  Filterdata: any;
  Cardcode: any;
  FavouriteOffersPaginated: any;
  CardName: any;  heartfunction:boolean = false;

   carouselOptions: OwlOptions = {
  loop: false,
  nav: false,
  dots: true,
  items: 1,
  autoWidth: false,
  autoHeight: false,
  responsive: {
    0: { items: 1 },
    600: { items: 1 },
    1000: { items: 1 }
  }
};


  constructor(private router: Router, private Ads: AdsService, private common: CommonService, private _sanitizer: DomSanitizer, public auth: AuthService,private cookies:CookieService, private card: CardServiceService) { }
  activeTab: number = -1;
  activepagination: number = 1;
  disabled;
  likeClass: string = "icon-heart-black";

  async ngOnInit(): Promise<any> {
    this.common.presentLoading();
    this.auth.accessToken = await this.common.Get("token");
    // to remove token 
//  if (this.auth.detailuser) {
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if(data?.status == 401){
        await this.common.hideLoading();
      }
      else  if (data?.response?.code == 1) {
        this.GetFavouriteOffers()
      }
      else {
        await this.common.hideLoading();
        this.common.ParseErrorAlert("", "", this.router, data);
      }

    })
    await Promise.all([this.GetOffer(), this.GetOffersCategories(), this.GetOffersPaginated()])

  }


  showModal(num) {
    this.modalObservable.next(num);
  }
  loginWithIdNum() {
    this.router.navigateByUrl("/LoginWithIdNum");
  }

  back(){
    this.router.navigateByUrl("/LandingPage"); 
  }
  LandingPageMyFavourites() {
    if (this.auth?.detailuser != null) {
      this.router.navigateByUrl("/LandingPageMyFavourites");

    }
    else {
      this.showModal(1)
    }
  }

  changeTab(e, obj) {

    this.common.presentLoading();
    this.totalpages = []
    this.activeTab = e;

    if (this.Cardcode == "") {

      if (e == '-1') {
        this.GetOffersPaginated();
      }
      else {
        this.Categoryid = obj.id;
        this.Ads.GetOffersPaginated(obj.id.toString(), "", false, 1).then((data: any) => {

          console.log('GetOffersPaginatedFilter', data)
          if (data?.response.code == 1) {
            this.OfferPaginated = data.response.content.data;
            if (this.OfferPaginated.length > 0) {

              
          if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

            this.OfferPaginated.forEach(element => {


              let Fav =  this.FavouriteOffers.filter(x=> x.offerid == element.id);
                if (Fav.length > 0) {

                  element['heart'] = true;

                }
                else{

                  element['heart'] = false;


                }

  
            });
            console.log('this.OfferPaginated', this.OfferPaginated)
          }

              for (var c = 1; c <= data.response.content.totalPages; c++) {

                this.totalpages.push(c);

              }

              this.common.hideLoading();
            }
            else if(this.OfferPaginated.length == 0){
              this.common.hideLoading();
              this.common.ParseErrorAlert('', 'OK', this.router, "No more Offers to show")
            }

          }
          else {
            this.common.hideLoading();
            this.common.ParseErrorAlert('', 'OK', this.router, data)
          }
        })
      }
    }
    else {

      if (e == '-1'){
        this.Categoryid = "";

      }
      else{
        this.Categoryid = obj.id;
        this.GetOfferPaginatedbyCard(this.Cardcode, e, this.Categoryid);

      }
    
    }

  }

  paginationTab(e) {

    this.common.presentLoading();
    this.activepagination = e;
    this.totalpages = []
    this.Ads.GetOffersPaginated(this.Categoryid != undefined ? this.Categoryid.toString() : "", "", false, e).then((data: any) => {
      console.log('GetOffersPaginatedbyPagination', data)
      if (data?.response.code == 1) {
        this.OfferPaginated = data.response.content.data;
        if (this.OfferPaginated.length > 0) {


          
          if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

            this.OfferPaginated.forEach(element => {


              let Fav =  this.FavouriteOffers.filter(x=> x.offerid == element.id);
                if (Fav.length > 0) {

                  element['heart'] = true;

                }
                else{

                  element['heart'] = false;


                }


  
            });
            console.log('this.OfferPaginated', this.OfferPaginated)
          }
          for (var c = 1; c <= data.response.content.totalPages; c++) {

            this.totalpages.push(c);
            console.log(this.totalpages)

          }
          this.common.hideLoading();
        }
        else if(this.OfferPaginated.length == 0){
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, "No more Offers to show")
        }

      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this.router, data)
      }
    })

    if(e == 1) {
      // alert("slide 1 clicked")
    }

  }

  likeItem() {
    if (this.likeClass == 'icon-heart-black') {
      this.likeClass = "icon-heart-active";
    } else {
      this.likeClass = "icon-heart-black";
    }
  }

  async logOut() { }


  GetOffer() {
    this.Ads.GetAds().then((data: any) => {
      if (data?.response.code == 1) {
        this.Adsoffer = data.response.content;

      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this.router, data)
      }
    })
  }

  GetOffersCategories() {

    this.Ads.GetOffersCategories().then((data: any) => {
      if (data?.response.code == 1) {
        this.OfferCategories = data.response.content.offerCategories;
        this.OfferCategories.forEach(element => {

          element.icon = this._sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64," + element.icon);

        });

      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this.router, data)
      }
    })
  }

  GetFavouriteOffersPaginated() {
    if (this.auth.detailuser != null) {
      this.Ads.GetFavouriteOffersPaginated(1, this.auth.accessToken).then((data: any) => {
        if (data?.response.code == 1) {
          this.FavouriteOffersPaginated = data.response.content.data;
          console.log('GetFavouriteOffersPaginated', this.FavouriteOffersPaginated)
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
    }
  }

  GetFavouriteOffers(){
    if (this.auth.detailuser != null) {
      this.Ads.GetFavouriteOffers( this.auth.accessToken).then((data: any) => {
        if (data?.response.code == 1) {
          this.FavouriteOffers = data.response.content;

          console.log('GetFavouriteOffers', this.FavouriteOffers)
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
  }
  }


  GetOffersPaginated() {
    this.totalpages = []
    this.Ads.GetOffersPaginated("", "", false, 1).then((data: any) => {
      console.log('GetOffersPaginatedall', data)
      if (data?.response.code == 1) {
        this.OfferPaginated =[...data.response.content.data];
        if (this.OfferPaginated.length > 0) {

          if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

            this.OfferPaginated.forEach(element => {


              let Fav =  this.FavouriteOffers.filter(x=> x.offerid == element.id);
                if (Fav.length > 0) {

                  element['heart'] = true;

                }
                else{

                  element['heart'] = false;


                }

              // this.FavouriteOffers.filter(ele => {
              //   if (element.id == ele.offerid) {

              //     element['heart'] = true;

              //     // this.FavPaginated.push(element)
              //   }
              //   else{

              //     element['heart'] = false;


              //   }
              // })

  
            });
            console.log('this.OfferPaginated', this.OfferPaginated)
          }


          for (var c = 1; c <= data.response.content.totalPages; c++) {

            this.totalpages.push(c);
            console.log(this.totalpages)

          }

        }
        else if(this.OfferPaginated.length == 0){
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, "No more Offers to show")
        }

        this.common.hideLoading();
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this.router, data)
      }
    })
  }

  async heartIcon(id) {
    this.heartfunction = true;
    this.common.presentLoading();
    await this.Ads.SaveFavourite(id, this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {

        console.log('FavouriteOffersaved')
        this.common.hideLoading();
        this.heartfunction = false;

      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', "OK", this.router, res);
      }
    });

  }

  addClassActive: boolean = false;
  showDrop() {
    if (this.addClassActive == false) {
      this.addClassActive = true;
    } else {
      this.addClassActive = false;
    }
  }

  async FilterIcon() {
    this.common.presentLoading();
    await this.card.FilterIcon(this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {

        this.Cardcode = "";
        this.CardName = ""
        this.Filterdata = res.response.content;
        this.showDrop();
        console.log('FilterIcon', this.Filterdata)
        this.common.hideLoading();
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', "OK", this.router, res);
      }
    });
  }


  GetOfferPaginatedbyCard(C, i, Cat) {

    if (this.addClassActive) {
      this.showDrop();
    }
    this.common.presentLoading();
    this.totalpages = []
    if(i == -1){
      this.CardName = C;
      this.Ads.GetOffersPaginated(Cat.toString(), "", false, 1).then((data: any) => {

        console.log('GetOffersPaginatedbyCard&Category', data)
        if (data?.response.code == 1) {
          this.OfferPaginated = data.response.content.data;
          if (this.OfferPaginated.length > 0) {

            if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

              this.OfferPaginated.forEach(element => {

  
                let Fav =  this.FavouriteOffers.filter(x=> x.offerid == element.id);
                  if (Fav.length > 0) {

                    element['heart'] = true;

                  }
                  else{

                    element['heart'] = false;

  
                  }
  

    
              });
              console.log('GetOffersPaginatedbyCard&Category', data)

            }

            for (var c = 1; c <= data.response.content.totalPages; c++) {

              this.totalpages.push(c);
              console.log(this.totalpages)

            }
          }
          else if(this.OfferPaginated.length == 0){
            this.common.hideLoading();
            this.common.ParseErrorAlert('', 'OK', this.router, "No more Offers to show")
          }


          this.common.hideLoading();
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
    }
    else if (Cat == "" || Cat == undefined || Cat == null) {
      this.Cardcode = C.cardCode;
      this.CardName = C.label;
      this.Ads.GetOffersPaginated(this.Categoryid.toString(), this.Cardcode, false, 1).then((data: any) => {

        console.log('GetOffersPaginatedbyCard', data)
        if (data?.response.code == 1) {
          this.OfferPaginated = data.response.content.data;
          if (this.OfferPaginated.length > 0) {

            if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

              this.OfferPaginated.forEach(element => {

  
                let Fav =  this.FavouriteOffers.filter(x=> x.offerid == element.id);
                  if (Fav.length > 0) {

                    element['heart'] = true;

                  }
                  else{

                    element['heart'] = false;

  
                  }
  

    
              });
              console.log('GetOffersPaginatedbyCard', data)
            }
            for (var c = 1; c <= data.response.content.totalPages; c++) {

              this.totalpages.push(c);
              console.log(this.totalpages)

            }
          }
          else if(this.OfferPaginated.length == 0){
            this.common.hideLoading();
            this.common.ParseErrorAlert('', 'OK', this.router, "No more Offers to show")
          }
          this.common.hideLoading();
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
    }
    else {

      this.Ads.GetOffersPaginated(Cat.toString(), C, false, 1).then((data: any) => {

        console.log('GetOffersPaginatedbyCard&Category', data)
        if (data?.response.code == 1) {
          this.OfferPaginated = data.response.content.data;
          if (this.OfferPaginated.length > 0) {
            for (var c = 1; c <= data.response.content.totalPages; c++) {

              this.totalpages.push(c);
              console.log(this.totalpages)

            }
          }
          else if(this.OfferPaginated.length == 0){
            this.common.hideLoading();
            this.common.ParseErrorAlert('', 'OK', this.router, "No more Offers to show")
          }


          this.common.hideLoading();
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
    }
  }

  OfferDetails(item){

    if(this.heartfunction == false ){

    // let key = this.cookies.generateKey();
    // this.cookies.set("offerdetail",JSON.stringify(item),false,key);
    let Cardcode = this.Cardcode == undefined ? "": this.Cardcode;
    let Pagination = '1'
    // this.activepagination == undefined ? 1 :this.activepagination

    let Categoryid =this.Categoryid == undefined? item.categoryId : this.Categoryid

   this.cookies.delete("offerdetail");
    this.cookies.set("offerid",item.id,true);
    this.cookies.set("offerpage","OffersLanding",true);
    this.cookies.set("Category",Categoryid,true);
    this.cookies.set("Cardcode",Cardcode,true);

    this.cookies.set("Pageination",Pagination.toString(),true);
    this.router.navigateByUrl('/LandingPageOfferDetails')

    }
  }




  SelctedCard(){
    this.CardName = "";
    this.Cardcode = "";
  }
}



